import Axios  from "axios"

export const getPlots = (plots) => async (dispatch) => {
    dispatch({
        type: 'PLOT_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/plot/getall/', {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )      
        if(status===200){            
            dispatch({
                type: 'PLOTS_GET_SUCCESS',
                payload: data.plots
            }) 
        }
    } catch (error) {
        dispatch({
            type: 'PLOT_ERROR'           
        })         
    }
}

export const getPlotDetail = (plot) => async (dispatch) => {
    dispatch({
        type: 'PLOT_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/plot/get/'+ plot, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )            
        if(status===200){            
            dispatch({
                type: 'PLOT_GET_DETAIL_SUCCESS',
                payload: data.plot
            })             
        }

    } catch (error) {
        dispatch({
            type: 'PLOT_ERROR'           
        })         
    }
}

export const getPlotsByFarm = (farm) => async (dispatch) => {
    dispatch({
        type: 'PLOT_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/plot/getbyfarm/'+ farm, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )            
        if(status===200){
            dispatch({
                type: 'PLOTS_BY_FARM_SUCCESS',
                payload: data.plots
            })             
        }

    } catch (error) {
        dispatch({
            type: 'PLOT_ERROR'           
        })         
    }
}

export const addPlot = (name, farm, crops) => async (dispatch) => {
    dispatch({
        type: 'PLOT_LOADING'
    })
    try {
        const {
            data,
            status
        } = await Axios.post(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/plot/register', {
                name: name,
                farm: farm,
                crops: crops
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if (status === 200) {
            let newPlot = {
                _id: data.id,
                name: name,
                farm: farm,
                crops: crops
            }
            dispatch({
                type: 'PLOT_ADD_SUCCESS',
                payload: newPlot
            })
        }
    } catch (error) {
        dispatch({
            type: 'PLOT_FAIL'
        })
    }
}

export const editPlot = (name, farm, crops, idPlot) => async (dispatch) => {
    dispatch({
        type: 'PLOT_LOADING'
    })
    try {
        await Axios.put(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/plot/edit/' + idPlot, {
                name: name,
                farm: farm,
                crops: crops
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        dispatch({
            type: 'PLOT_EDIT_SUCCESS',
            payload: {
                name: name,
                farm: farm,
                crops: crops,
                _id: idPlot
            }
        })
    } catch (error) {
        dispatch({
            type: 'PLOT_ERROR'
        })
    }
}

export const removePlot = (idPlot) => async (dispatch) => {
    try {
        const {
            data,
            status
        } = await Axios.delete(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/plot/remove/' + idPlot, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'PLOT_DELETE_SUCCESS',
                payload: {
                    idPlot: idPlot,
                    message: data.message,
                    count: data.count
                }
            })
        }else{
            dispatch({
                type: 'PLOT_DELETE_NOT_SUCCESS',
                payload: {
                    message: data.message,
                    count: data.count
                }
            })
        }
    } catch (error) {
        dispatch({
            type: 'PLOT_ERROR'
        })
    }
}